import { CompetencyUsageAPI } from "../types";

type DisplayMode = "currency" | "credits";

function parseCompetency(dateStr: string): Date | null {
  // daily: YYYY-MM-DD
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
    const [y, m, d] = dateStr.split("-").map(Number);
    return new Date(y, m - 1, d);
  }
  // monthly: YYYY-MM
  if (/^\d{4}-\d{2}$/.test(dateStr)) {
    const [y, m] = dateStr.split("-").map(Number);
    return new Date(y, m - 1, 1);
  }
  return null;
}

export function buildChartData(
  api: CompetencyUsageAPI,
  series: Array<{ type: number; key: string }>,
  displayMode: DisplayMode,
) {
  const isDaily = api.competency_type === "daily";

  const data = api.usage.map((periodData) => {
    const d = parseCompetency(periodData.competency);

    const label = (() => {
      if (isDaily) {
        if (d)
          return d
            .toLocaleDateString("pt-BR", { day: "numeric", month: "numeric" })
            .replace(".", "");
        return periodData.competency;
      }
      if (d) {
        return d
          .toLocaleDateString("pt-BR", { month: "short" })
          .replace(".", "");
      }
      return periodData.competency;
    })();

    const longLabel = (() => {
      if (d) {
        const month = d.toLocaleDateString("pt-BR", { month: "long" });
        const year = d.toLocaleDateString("pt-BR", { year: "numeric" });
        return `${month} ${year}`;
      }
      return periodData.competency;
    })();

    const point: Record<string, any> = {
      period: label,
      longLabel,
      originalData: periodData.bookings_usage,
    };

    for (const s of series) {
      const match = periodData.bookings_usage.find((b) => b.type === s.type);
      const raw =
        displayMode === "currency"
          ? parseFloat(match?.monetary_value ?? "0")
          : Number(match?.credits_value ?? 0);

      point[s.key] = Number.isFinite(raw) ? raw : 0;
    }

    return point;
  });

  return { isDaily, data };
}
